<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      syncValueChange
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author Lin
// Date 2022-08-02 15:16:32

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

export default {
    name: "sithMesMstMaterialWorkflowTaskView",
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    components: {WorkflowTaskComplete, WorkflowProcessLine},
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesMstMaterial/complete-feedback";
        },
        config() {
            return {
                viewInfos: [
                    {
                        title: '来源项目信息',
                        entityName: 'sithMesPrdProjectPlanPrp',
                        id: this.taskLocalVariables.projectPlanId
                    },
                    {
                        title: 'BOM结构',
                        queryApi: process.env.VUE_APP_SITHMES_MST_URL + '/sithMesMstMaterial/queryBom?materialNumber=' + this.taskLocalVariables.materialNumberFrom,
                        data: {},
                        tableConfig: {
                            enable: true,
                            treeIdName: 'componentNumber',
                            treeLevelName: 'level',
                            treeParentIdName: 'parentNumber',
                            expendAll: true,
                            highLightRow: row => {
                                if (row.componentNumber === this.$_emWorkflowTaskMixin_businessData.material) {
                                    return 'warning';
                                }
                            }
                        },
                    }
                ],
                'task1': {
                    name: "确定make or buy",
                    forceApprove: true,
                    variables: [
                        {
                            label: 'Make/Buy?',
                            name: 'makeOrBuy',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: 0, text: 'MAKE'},
                                {value: 1, text: 'BUY'},
                            ],
                            require: true,
                            initData: true,
                        },
                        {
                            label: '中文物料描述',
                            name: 'materialDescription',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        }
                    ],
                    setApproveByVariable: [{
                        variableName: 'makeOrBuy',
                        handler: (approve, val) => {
                            if (val !== undefined) {
                                return val;
                            }
                            return approve;
                        }
                    }],
                    approveToNextTask: 'parallelGatewayStart'
                },
                'task2': {
                    name: '维护财务主数据',
                    variables: [
                        {
                            label: '税目',
                            name: 'taxCategory',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                        {
                            label: '税分类',
                            name: 'taxClass',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        }
                    ],
                    approveToNextTask: 'parallelGatewayStart'
                },
                'task3': {
                    name: '维护OM数据',
                    variables: [
                        {
                            label: 'Ind',
                            name: 'ic',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: '1', text: 'PTO'},
                                {value: '2', text: 'PTS'}
                            ],
                            require: true,
                            initData: true,
                        }
                    ],
                    approveToNextTask: 'parallelGatewayStart'
                },
                'task4': {
                    name: '维护TC数据',
                    variables: [
                        {
                            label: '采购类型',
                            name: 'procType',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: 'E', text: 'E'},
                                {value: 'F', text: 'F'}
                            ],
                            require: true,
                            initData: true,
                        },
                        {
                            label: 'IPT',
                            name: 'ipt',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                    ],
                    approveToNextTask: 'parallelGatewayStart'
                },
                'task5': {
                    name: '维护物料文件号',
                    variables: [
                        {
                            label: '物料文件号',
                            name: 'documentNumber',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                        {
                            label: 'TextQA',
                            name: 'textQa',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                    ],
                    approveToNextTask: 'parallelGatewayStart'
                },
                'task6': {
                    name: '维护采购主数据',
                    variables: [
                        {
                            label: 'MinLotSize',
                            name: 'minLotSze',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                        {
                            label: '采购组',
                            name: 'pgr',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                        {
                            label: 'Planned delivery time',
                            name: 'pdt',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                        {
                            label: 'GR processing time',
                            name: 'grt',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            initData: true,
                        },
                    ],
                    approveToNextTask: 'parallelGatewayStart'
                },
                'task7': {
                    name: '主数据扩展',
                    approveToNextTask: 'complete'
                },
                'parallelGatewayStart': {
                    name: '各部门维护主数据'
                },
                'parallelGatewayEnd': {
                    name: '各部门维护完成'
                },
                'complete': {
                    name: '结束'
                }
            }
        }
    }
};
</script>